<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Applies To"
      @click.native.stop
    >
      <v-select
        v-model="appliesToValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="typeName"
        placeholder="Select from list"
        multiple
        :options="appliesToOptions"
        :reduce="activityType => activityType._id"
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Date Range"
    >
      <b-input-group>
        <flat-pickr
          v-model="dateRangeValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group label="Status">
      <b-form-radio-group
        v-model="statusFilterValue"
        :options="statusRadioOptions"
        name="status-radios-stacked"
        stacked
      />
    </b-form-group>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BFormRadioGroup, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BFormRadioGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: null,
    },
    dateRange: {
      type: [String, null],
      default: null,
    },
    appliesTo: {
      type: [Array, null],
      default: null,
    },
    statusRadioOptions: {
      type: Array,
      required: true,
    },
    appliesToOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dateRangeValue: this.dateRange,
      statusFilterValue: this.statusFilter,
      appliesToValue: JSON.parse(JSON.stringify(this.appliesTo)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler(val) {
        this.dateRangeValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = val
      },
    },
    appliesTo: {
      immediate: true,
      handler(val) {
        this.appliesToValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.dateRangeValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:dateRange', this.dateRangeValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:appliesTo', this.appliesToValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.dateRangeValue = ''
      this.statusFilterValue = null
      this.appliesToValue = []
      this.$emit('update:dateRange', this.dateRangeValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:appliesTo', this.appliesToValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
